<template>
  <div class="closing-popup">
    <p>
      closing detail
    </p>
    <!-- View closing infos -->
    <div class="maincontent">
      <div>
        <div class="label f8">{{ $t('From') }}</div>
        <div v-if="!editingMode">
          <div class="content f2">{{ startDayFormatted }}</div>
          <div class="content f2">{{ startTimeFormatted }}</div>
        </div>
        <div class="inputgroup" v-else>
          <UIDateTimepicker
            :value="editedClosing.startTime"
            @update-model="changeStartTimeDate"
            :twentyFourHourTime=localStation.twentyFourHourTime
            :locale="localStation.locale"
            :options="startTimeDatePickerConfig"
          />
          <!-- <div class="warningmessage" v-if="closureEvent.confirmed && !closureEvent.startTime" >{{ $t('Select a start time to close the station') }}</div> -->
        </div>
      </div>
      <div>
        <div class="label f8">{{ $t('Until') }}</div>
        <div v-if="!editingMode">
          <div class="content f2">{{ endDayFormatted }}</div>
          <div class="content f2">{{ endTimeFormatted }}</div>
        </div>
        <div class="inputgroup" v-else>
          <UIDateTimepicker
            :value= "editedClosing.endTime"
            @update-model="changeEndTimeDate"
            :twentyFourHourTime=localStation.twentyFourHourTime
            :locale="localStation.locale"
            :options="endTimeDatePickerConfig"
            :error="true"
          />
          <!-- <div class="warningmessage" v-if="closureEvent.confirmed && !closureEvent.endTime" >{{ $t('Select an end time to close the station') }}</div> -->
        </div>
      </div>
      <div v-if="false">  <!-- Disabled for the time being per request -->
        <div v-if="!editingMode">
          <div class="label f8">{{ $t('Minimum Booking') }}</div>
          <div class="content f2">{{ $t(minimumBookingWindowFormatted) }}</div>
        </div>
        <div class="inputgroup" v-else>
          <div class="label f8">{{ $t('Minimum Booking') }}</div>
          <div class="range">
            <UIRange
              class="minimumBookingWindow-range"
              :min=0
              :max=1440
              :value=editedClosing.minimumBookingWindow
              @input="updateMinimumBookingWindow"
              step="15"
            />
            <div class="minimumBookingWindow-selection f5">{{ textMinimumBookingWindow }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- View buttons -->
    <div class="bottombar" v-if="!editingMode && !cancelClosingConfirm">
      <div class="left">
        <UIButton
          :ghost="true"
          class="TO_BE_CHANGED"
          @click="showEditClosing"
        >{{ $t("Edit") }}</UIButton>
      </div>
      <div class="right">
        <UIButton class="TO_BE_CHANGED"
          @click="showCancelClosing"
        >{{ $t("Re-Open") }}</UIButton>
      </div>
    </div>

    <!-- Edit buttons -->
    <div class="bottombar" v-if="editingMode">
      <div class="left">
        <UIButton
          :ghost="true"
          class="TO_BE_CHANGED"
          @click="confirmEditClosing"
        >{{ $t("Confirm Edit") }}</UIButton>
      </div>
      <div class="right">
        <UIButton class="TO_BE_CHANGED"
          @click="showEditClosing"
        >{{ $t("Cancel edit") }}</UIButton>
      </div>
    </div>

    <!-- Confirm re-opening buttons -->
    <div class="bottombar" v-if="cancelClosingConfirm">
      <div class="left">
        <UIButton
          :ghost="true"
          class="TO_BE_CHANGED"
          @click="confirmCancelClosing"
        >{{ $t("Confirm") }}</UIButton>
      </div>
      <div class="right">
        <UIButton class="TO_BE_CHANGED"
          @click="showCancelClosing"
        >{{ $t("Cancel") }}</UIButton>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment-timezone';
import deepmerge from 'deepmerge';

import UIButton from '@/core/shared/components/ui/UIButton';
import UIRange from '@/core/shared/components/ui/UIRange';
import UIDateTimepicker from '@/core/shared/components/ui/UIDateTimepicker';

@Component({
  props: {
    locationId: {
      type: String,
      required: true,
    },
    stationId: {
      type: String,
      required: true,
    },
    closingId: {
      type: String,
      required: true,
    },
  },
  components: {
    UIButton,
    UIRange,
    UIDateTimepicker,
  },
})
export default class ClosingDetailRoute extends Vue {
  editingMode = false;
  cancelClosingConfirm = false;

  editedClosing = {
    id: this.closingId,
    startTime: this.closing.startTime,
    endTime: this.closing.endTime,
    minimumBookingWindow: this.closing.minimumBookingWindow,
    stationId: this.stationId,
    locationId: this.locationId,
  };

  endTimeDatePickerConfig = {
    enableTime: true,
    minDate: new Date(Date.now()),
  };

  startTimeDatePickerConfig = {
    enableTime: true,
    minDate: 'today',
  };

  textMinimumBookingWindow = '2H00';

  get currentTime () { return this.$store.getters.currentTime; }

  get startDayFormatted () { return moment(this.closing.startTime).format('LL'); }
  get endDayFormatted () { return moment(this.closing.endTime).format('LL'); }

  get startTimeFormatted () { return moment(this.closing.startTime).format('h:mma'); }
  get endTimeFormatted () { return moment(this.closing.endTime).format('h:mma'); }

  // get minimumBookingWindowFormatted () { return this.closing.minimumBookingWindow + ' minutes'; }
  get minimumBookingWindowFormatted () { return Math.floor(this.closing.minimumBookingWindow / 60) + 'H' + (this.closing.minimumBookingWindow % 60).toString().padStart(2, '0'); }

  get closing () {
    const closing = this.$store.getters['entities/StationTemporaryClosing'](this.closingId) || {};
    return deepmerge({}, closing);
  }

  get ended () {
    return moment(this.closing.endTime).diff(moment(this.currentTime)) < 0 && this.closing.startTime;
  }

  get length () {
    return Math.round(moment(this.closing.endTime).diff(this.closing.startTime) / 1000 / 60);
  }

  get localStation () {
    return this.$store.getters['entities/Location'](this.locationId);
  }

  // Inputs
  changeStartTimeDate (selectedDate) {
    this.changeEndTimeMinDate(selectedDate);
    this.$set(this.editedClosing, 'startTime', selectedDate);
    this.$delete(this.editedClosing, 'endTime');
  }

  changeEndTimeMinDate (selectedDate) {
    this.$set(this.endTimeDatePickerConfig, 'minDate', selectedDate);
  }

  changeEndTimeDate (selectedDate) {
    this.$set(this.editedClosing, 'endTime', selectedDate);
  }

  updateMinimumBookingWindow (e) {
    const selection = new Date();
    selection.setHours(Math.floor(e.target.value / 60), e.target.value % 60);
    this.$set(this.editedClosing, 'minimumBookingWindow', parseInt(e.target.value));
    this.textMinimumBookingWindow = selection.getHours() + 'H' + selection.getMinutes().toString().padStart(2, '0');
  }

  // Buttons
  showEditClosing () {
    this.editingMode = !this.editingMode;
    this.textMinimumBookingWindow = Math.floor(this.closing.minimumBookingWindow / 60) + 'H' + this.closing.minimumBookingWindow % 60;
  }

  showCancelClosing () {
    this.cancelClosingConfirm = !this.cancelClosingConfirm;
  }

  async confirmCancelClosing () {
    if (this.cancelClosingConfirm) {
      this.saving = true;
      try {
        await this.$store.dispatch('reopenStation', this.editedClosing);
        this.$router.push({ name: 'overview' });
      } catch (e) {
        // Error flash is already shown
      }
      this.saving = false;
    }
  }

  async confirmEditClosing () {
    if (this.editingMode) {
      this.saving = true;
      await this.$store.dispatch('closeStation', this.editedClosing);

      this.$store.dispatch('getStationClosings', { locationId: this.locationId }).then(() => {
        this.saving = false;
        this.$router.push({ name: 'overview' });
      });
    }
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.range {
  display: flex;
    width: 100%;
    height: 50px;
    align-items: center;
    justify-content: space-between;

  & .minimumBookingWindow-selection {
    width: max-content;
  }

  & .minimumBookingWindow-range {
    width: calc(90% - 3rem);
    margin-left: -1rem;
  }
}

.closing-popup {
  display: grid;
  padding: var(--spacingSm);

  @media (--tablet) {
    padding: 0;
    min-width: 75vw;
    max-width: 90vw;
  }

  @media (--desktop) {
    min-width: 60vw;
  }

  @media (--desktopXL) {
    min-width: 50vw;
  }

  & .maincontent {
    display: grid;

    @media (--tablet) {
      padding: var(--spacingMd);
      grid-template-columns: 50% 50%;
    }

    & .label {
      margin-bottom: var(--spacingXS);
      color: var(--colorManatee);
      margin-top: 10px;
    }
  }

  & .bottombar {
    @media (--tablet) {
      display: flex;
      align-items: flex-start;
      padding: 0;
    }

    & .left {
      display: flex;
      flex: 1 0 50%;
      align-items: center;
      padding: var(--spacingSm) 0 0 0;

      @media (--tablet) {
        border-left: 0.1rem solid var(--colorCasper);
        padding: var(--spacingSm) var(--spacingMd);
      }

      & .TO_BE_CHANGED {
        flex: 1 1 auto;
        margin-left: auto;
      }
    }

    & .right {
      display: flex;
      flex: 1 0 50%;
      align-items: center;
      padding: var(--spacingSm) 0;

      @media (--tablet) {
        border-left: 0.1rem solid var(--colorCasper);
        padding: var(--spacingSm) var(--spacingMd);
      }

      & .TO_BE_CHANGED {
        flex: 1 1 15rem;
        display: flex;
        align-items: center;
        justify-content: center;
        align-self: flex-start;

        @media (--tablet) {
          margin-right: var(--spacingSm);
        }
      }
    }
  }
}
</style>
